import React, {useEffect, useState} from 'react';
import {
    Paper,
    Avatar,
    TextField,
    Button,
    Switch,
    FormControlLabel,
    Checkbox,
    Typography,
    Chip,
    Input, MenuItem, withStyles
} from 'material-ui';
import {
    ArrowDropUp as ArrowDropUpIcon,
    ArrowDropDown as ArrowDropDownIcon,
    Clear as ClearIcon,
    Cancel as CancelIcon
} from 'material-ui-icons';
import ContainerHeader from 'components/ContainerHeader';
import {get, postForm, urlPrefix} from 'engine/dataServices';
import DataTable from 'components/customized/tables/datatable';
import jMoment from 'moment-jalaali';
import {Card, CardBody, CardFooter, CardHeader, CardSubtitle, CardText} from 'reactstrap';
import Validator from 'components/Validator';
import {useDropzone} from 'react-dropzone';
import {NotificationManager} from 'react-notifications';
import Select from 'react-select';
import PropTypes from "prop-types";
import Loading from 'app/loading';

const ITEM_HEIGHT = 48;

const usersHeadTable = [
    {id: 'id', numeric: false, disablePadding: true, label: 'شناسه'},
    {id: 'image', numeric: false, disablePadding: true, label: 'آواتار'},
    {id: 'username', numeric: false, disablePadding: true, label: 'نام کاربری'},
    {id: 'lastLoginDate', numeric: false, disablePadding: true, label: 'تاریخ آخرین ورود'},
    {id: 'createdDate', numeric: true, disablePadding: false, label: 'تاریخ ایجاد'},
    {id: 'modifiedDate', numeric: true, disablePadding: false, label: 'تاریخ آخرین ویرایش'}
];

const thumb = {
    display: 'inline-flex',
    border: '1px solid #eaeaea',
    marginBottom: 8,
    marginRight: 8,
    width: 100,
    height: 100,
    padding: 4,
    boxSizing: 'border-box'
};

const thumbInner = {
    display: 'flex',
    minWidth: 0,
    overflow: 'hidden'
};

const thumbsContainer = {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginTop: 16
};

const img = {
    display: 'block',
    width: 'auto',
    height: '100%'
};

const imageThumb = {
    display: 'flex',
    width: 80,
    height: 80,
    padding: 4,
    boxSizing: 'border-box'
};

function Dropzone(props) {
    const [files, setFiles] = useState([]);
    const {getRootProps, getInputProps} = useDropzone({
        accept: 'image/*',
        /*minSize : 0,
        maxSize: 20000,*/
        onDrop: items => {
            const maxUploadSize = 10000000;

            if (items.length > 1) {
                NotificationManager.error('تنها می توان یک تصویر برای کاربر بارگزاری نمود.');
            }

            let acceptedFiles = [];

            const item = items[0];
            if (item.size <= maxUploadSize)
                acceptedFiles.push(item);
            else
                NotificationManager.error(`حداکثر مجاز برای حجم هر تصویر
                    ${maxUploadSize / 1000} 
                     کیلوبایت می باشد. حجم تصویر با نام
                     ${item.name}
                     بیش از مقدار مورد قبول می باشد.`
                    , 'خطای کاربری');

            setFiles(acceptedFiles.map(file => Object.assign(file, {
                preview: URL.createObjectURL(file)
            })));

            if (items.length > 0) {
                this.setState({uploadFiles: acceptedFiles});
            }
        }
    });

    const thumbs = files.map(file => {
        return (
            <div style={thumb} key={file.name}>
                <div style={thumbInner}>
                    <img
                        src={file.preview}
                        style={img}
                    />
                </div>
            </div>
        );
    });

    useEffect(() => () => {
        // Make sure to revoke the data uris to avoid memory leaks
        files.forEach(file => URL.revokeObjectURL(file.preview));
    }, [files]);

    return (
        <section style={{display: 'flex', flexDirection: 'column', marginRight: 50, marginLeft: 50}}>
            <div {...getRootProps({className: 'dropzone'})} style={{
                flex: 1,
                flexDirection: 'column',
                alignItems: 'center',
                padding: 20,
                borderStyle: 'dashed',
                borderRadius: 2,
                borderColor: '#eeeeee',
                borderWidth: 2,
                justifyContent: 'center',
                textAlign: 'center'
            }} className="bg-primary">
                <input {...getInputProps()} />
                <p>
                    تصویر کاربری جدید - تصویر کاربری مورد نظر خود را به اینجا Drag & Drop نموده و یا در این ناحیه کلیک
                    نمایید.
                </p>
                <aside style={thumbsContainer}>
                    {thumbs}
                </aside>
            </div>
        </section>
    );
}

let ImageThumbs = props => {
    let parent = props.props;
    let {image} = parent.state;
    image = (image) ? urlPrefix + image : require('assets/Images/TolitonAvatar.png');

    return (
        <Avatar src={image} className="size-100 mt-2 mb-2"
                style={{margin: 'auto'}}/>
    );
}

const formFunctionTypes = {
    Add: {
        name: 'کاربر جدید'
    },
    Edit: {
        name: 'ویرایش کاربر'
    }
}

function SelectWrapped(props) {
    const {classes, ...other} = props;

    return (
        <Select
            optionComponent={Option}
            noResultsText={<Typography>{'No results found'}</Typography>}
            arrowRenderer={arrowProps => {
                return arrowProps.isOpen ? <ArrowDropUpIcon/> : <ArrowDropDownIcon/>;
            }}
            clearRenderer={() => <ClearIcon/>}
            valueComponent={valueProps => {
                const {value, children, onRemove} = valueProps;

                const onDelete = event => {
                    event.preventDefault();
                    event.stopPropagation();
                    onRemove(value);
                };

                if (onRemove) {
                    return (
                        <Chip
                            tabIndex={-1}
                            label={children}
                            style={{
                                margin: 5,
                            }}
                            deleteIcon={<CancelIcon onTouchEnd={onDelete}/>}
                            onDelete={onDelete}
                        />
                    );
                }

                return <div className="Select-value">{children}</div>;
            }}
            {...other}
        />
    );
}

class Option extends React.Component {
    handleClick = event => {
        this.props.onSelect(this.props.option, event);
    };

    render() {
        const {children, isFocused, isSelected, onFocus} = this.props;

        return (
            <MenuItem
                onFocus={onFocus}
                selected={isFocused}
                onClick={this.handleClick}
                component="div"
                style={{
                    fontWeight: isSelected ? 500 : 400,
                }}
            >
                {children}
            </MenuItem>
        );
    }
}

const styles = theme => ({
    root: {
        flexGrow: 1,
        minHeight: 100,
        justifyItems: 'center',
        width: '90%',
    },
    chip: {
        margin: theme.spacing.unit / 4,
    },
    // We had to use a lot of global selectors in order to style react-select.
    // We are waiting on https://github.com/JedWatson/react-select/issues/1679
    // to provide a better implementation.
    // Also, we had to reset the default style injected by the library.
    '@global': {
        '.Select-control': {
            display: 'flex',
            alignItems: 'center',
            border: 0,
            height: 'auto',
            background: 'transparent',
            '&:hover': {
                boxShadow: 'none',
            },
        },
        '.Select-multi-value-wrapper': {
            flexGrow: 1,
            display: 'flex',
            flexWrap: 'wrap',
        },
        '.Select--multi .Select-input': {
            margin: 0,
        },
        '.Select.has-value.is-clearable.Select--single > .Select-control .Select-value': {
            padding: 0,
        },
        '.Select-noresults': {
            padding: theme.spacing.unit * 2,
        },
        '.Select-input': {
            display: 'inline-flex !important',
            padding: 0,
            height: 'auto',
        },
        '.Select-input input': {
            background: 'transparent',
            border: 0,
            padding: 0,
            cursor: 'default',
            display: 'inline-block',
            fontFamily: 'inherit',
            fontSize: 'inherit',
            margin: 0,
            outline: 0,
        },
        '.Select-placeholder, .Select--single .Select-value': {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            display: 'flex',
            alignItems: 'center',
            fontFamily: theme.typography.fontFamily,
            fontSize: theme.typography.pxToRem(16),
            padding: 0,
        },
        '.Select-placeholder': {
            opacity: 0.42,
            color: theme.palette.common.black,
        },
        '.Select-menu-outer': {
            backgroundColor: theme.palette.background.paper,
            boxShadow: theme.shadows[2],
            position: 'absolute',
            left: 0,
            top: `calc(100% + ${theme.spacing.unit}px)`,
            width: '100%',
            zIndex: 2,
            maxHeight: ITEM_HEIGHT * 4.5,
        },
        '.Select.is-focused:not(.is-open) > .Select-control': {
            boxShadow: 'none',
        },
        '.Select-menu': {
            maxHeight: ITEM_HEIGHT * 4.5,
            overflowY: 'auto',
        },
        '.Select-menu div': {
            boxSizing: 'content-box',
        },
        '.Select-arrow-zone, .Select-clear-zone': {
            color: theme.palette.action.active,
            cursor: 'pointer',
            height: 21,
            width: 21,
            zIndex: 1,
        },
        // Only for screen readers. We can't use display none.
        '.Select-aria-only': {
            position: 'absolute',
            overflow: 'hidden',
            clip: 'rect(0 0 0 0)',
            height: 1,
            width: 1,
            margin: -1,
        },
    },
});


class Users extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            uploadFiles: [],
            loading: false,
            showEditContainer: false,
            editContainerFunctionType: formFunctionTypes.Add,
            usersData: [],
            userRolesData: [],
            username: '',
            password: '',
            nickName: '',
            firstName: '',
            lastName: '',
            bio: '',
            image: '',
            isActive: 1,
            enableNotification: 1,
            changePassword: 0,
            userRoles: '',
            createDate: '',
            lastModified: '',
            lastLoginDate: '',
            partnerPercent: 0,
            producerName: ''
        };

        this.myRef = React.createRef();

        jMoment.loadPersian({dialect: 'persian-modern'});
        this.validator = Validator();
        Dropzone = Dropzone.bind(this);
    }

    componentWillMount() {
        this.loadUsersData();
        this.loadUserRoles();
    }

    handleLoading = (status) => {
        this.setState({loading: status})
    }

    normalizeDates = (datetime) => jMoment(datetime).year() > 2000 ? jMoment(datetime).format('LLLL') : '...';

    async loadUsersData() {
        const res = await get('User/GetAll');
        if (res.status == 200) {
            const responseData = await res.json();
            const _data = [];

            responseData.map(x => {
                let userImage = (x.Setting.UserImage) ? urlPrefix + x.Setting.UserImage : require('assets/Images/TolitonAvatar.png');

                _data.push({
                    id: x.Id,
                    image: <Avatar src={userImage} className="size-60 mt-2 mb-2"
                                   style={{margin: 'auto'}}/>,
                    username: x.Mobile,
                    lastLoginDate: this.normalizeDates(x.LastLoginDate),
                    createdDate: this.normalizeDates(x.CreatedDate),
                    modifiedDate: this.normalizeDates(x.ModifiedDate)
                });
            });

            this.setState({usersData: _data});
        }
    }

    async loadUserRoles() {
        const res = await get('Role/GetAll');
        if (res.status == 200) {
            const responseData = await res.json();
            const _data = [];
            responseData.map(x =>
                _data.push({
                    value: x.Id,
                    label: x.Name
                })
            )
            this.setState({userRolesData: _data});
        }
    }

    async addFunction() {
        this.clearForm();
        this.setState({showEditContainer: true, editContainerFunctionType: formFunctionTypes.Add});
        this.scroll(this.myRef);

    }

    async editFunction() {
        let username = null;

        let selectedId = event.target.getAttribute('data-id');
        if (!selectedId) selectedId = event.target.offsetParent.getAttribute('data-id');
        let rowSelected = event.target.getAttribute('data-extra');
        if (!rowSelected) rowSelected = event.target.offsetParent.getAttribute('data-extra');
        if (rowSelected) {
            username = JSON.parse(rowSelected).username;
        }
        if (username) {
            this.clearForm();
            await this.loadUserDetail(username);
            this.setState({showEditContainer: true, editContainerFunctionType: formFunctionTypes.Edit});
            this.scroll(this.myRef);
        } else {
            NotificationManager.error('اطلاعات کاربر انتخاب شده یافت نشد.');
        }
    }

    async submitBtn() {
        const {editContainerFunctionType, userRoles} = this.state;

        try {
            let validFields = true;
            let fields = ['نام', 'نام مستعار', 'نام کاربری', 'نام خانوادگی', 'نقش های کاربر', 'کلمه عبور'];

            const isProducer = (userRoles) && (userRoles.split(',').some(x => x == 2));
            debugger;
            if(isProducer)
                fields.push('عنوان فروشگاه', 'درصد شراکت');

            fields.map((field) => {
                if (!this.validator.fieldValid(field)) {
                    validFields = false;
                    return;
                }
            });

            //let validFields = this.validator.allValid();
            debugger;
            if (validFields) {
                this.handleLoading(true);
                switch (editContainerFunctionType) {
                    case formFunctionTypes.Add:
                        await this.addUser();
                        break;
                    case formFunctionTypes.Edit:
                        await this.editUser();
                        break;
                }
            } else {
                this.validator.showMessages();
                this.forceUpdate();
            }
        } catch (e) {
            console.log(e);
        } finally {
            this.handleLoading(false);
        }
    }

    closeEditContainer() {
        this.clearForm();
        this.setState({showEditContainer: false});
    }

    addUser = async () => {
        let {uploadFiles, username, password, nickName, firstName, lastName, bio, isActive, enableNotification, userRoles, userRolesData, partnerPercent, producerName} = this.state;

        let roles = [];

        userRoles.split(',').map(x => {
            const urd = userRolesData.find(y => y.value == x);
            roles.push({Id: urd.value, Name: urd.label});
        });

        let form = new FormData();
        form.append('UploadedImages', uploadFiles[0]);
        form.append('Username', username);
        form.append('Password', password);
        form.append('NickName', nickName);
        form.append('Active', Boolean(isActive));
        form.append('Notification', Boolean(enableNotification));
        form.append('FirstName', firstName);
        form.append('LastName', lastName);
        form.append('Biography', bio);
        form.append('ProducerPartnerPercent', partnerPercent);
        form.append('ProducerName', producerName);
        form.append('RolesJson', JSON.stringify(roles));

        const response = await postForm('User/Add', form);
        switch (response.status) {
            case 200:
                NotificationManager.success(`کاربر ${username} با موفقیت در تولیتون ثبت شد.`, 'عملیات موفق');
                this.setState({showEditContainer: false});
                this.loadUsersData();
                return;
        }
        NotificationManager.error(`خطا در ثبت کاربر`, 'خطا');
    }

    editUser = async () => {
        let {uploadFiles, username, password, nickName, firstName, lastName, bio, isActive, enableNotification, userRoles, userRolesData, changePassword, partnerPercent, producerName} = this.state;

        let roles = [];

        userRoles.split(',').map(x => {
            const urd = userRolesData.find(y => y.value == x);
            roles.push({Id: urd.value, Name: urd.label});
        });

        let form = new FormData();
        form.append('UploadedImages', uploadFiles[0]);
        form.append('Username', username);
        form.append('Password', password);
        form.append('ChangePassword', Boolean(changePassword));
        form.append('NickName', nickName);
        form.append('Active', Boolean(isActive));
        form.append('Notification', Boolean(enableNotification));
        form.append('FirstName', firstName);
        form.append('LastName', lastName);
        form.append('Biography', bio);
        form.append('ProducerPartnerPercent', partnerPercent);
        form.append('ProducerName', producerName);
        form.append('RolesJson', JSON.stringify(roles));

        const response = await postForm('User/Update', form);
        switch (response.status) {
            case 200:
                NotificationManager.success(`کاربر ${username} با موفقیت در تولیتون ویرایش شد.`, 'عملیات موفق');
                this.setState({showEditContainer: false});
                this.clearForm();
                this.loadUsersData();
                return;
        }
        NotificationManager.error(`خطا در ثبت کاربر`, 'خطا');
    }


    clearForm() {
        this.setState({
            username: '',
            password: '',
            nickName: '',
            firstName: '',
            lastName: '',
            bio: '',
            image: '',
            isActive: 1,
            enableNotification: 1,
            changePassword: 0,
            partnerPercent: 0,
            producerName: '',
            userRoles: '',
            createDate: '',
            lastModified: '',
            lastLoginDate: ''
        });
    }

    async loadUserDetail(username) {
        const res = await get(`User/GetUserAccount?username=${username}`);
        if (res.status == 200) {
            const _data = await res.json();

            let _userRoles = '';
            _data.Roles.map(x => {
                if (_userRoles)
                    _userRoles += ',';
                _userRoles += `${x.Id}`;
            });
            debugger;
            this.setState({
                username: _data.UserName,
                password: '********',
                nickName: _data.NickName,
                firstName: _data.FirstName,
                lastName: _data.LastName,
                bio: _data.Biography,
                image: _data.Image,
                isActive: _data.Active,
                enableNotification: _data.Notification,
                changePassword: 0,
                producerName: _data.ProducerName,
                partnerPercent: _data.ProducerPartnerPercent,
                userRoles: _userRoles,
                createDate: this.normalizeDates(_data.CreatedDate),
                lastModified: this.normalizeDates(_data.ModifiedDate),
                lastLoginDate: this.normalizeDates(_data.LastLoginTime)
            });
        }
    }

    scroll(ref) {
        setTimeout(() => {
            ref.current.scrollIntoView({behavior: 'smooth'})
        }, 100)
    }

    handleChange = name => event => {
        this.setState({
            [name]: event.target.value,
        });
    };

    handleSwitchChange = name => (event, checked) => {
        this.setState({[name]: checked});
    };

    handleChangeMulti = multi => {
        this.setState({
            userRoles: multi,
        });
    };

    render() {
        const {classes} = this.props;
        const {usersData, showEditContainer, editContainerFunctionType, userRolesData, loading} = this.state;
        const {username, password, image, nickName, firstName, lastName, bio, isActive, enableNotification, changePassword, userRoles, createDate, lastModified, lastLoginDate, partnerPercent, producerName} = this.state;

        const isProducer = (userRoles) && (userRoles.split(',').some(x => x == 2));

        return (
            <div className="animated slideInUpTiny animation-duration-3">
                {loading && <Loading/>}
                <ContainerHeader match={this.props.match} title="مدیریت کاربران"/>
                <Paper>
                    <DataTable columnData={usersHeadTable} data={usersData} addFunc={this.addFunction.bind(this)}
                               editFunc={this.editFunction.bind(this)}/>
                </Paper>

                <div id="editContainer" ref={this.myRef} style={{paddingTop: 5}}>
                    {showEditContainer && (
                        <section>
                            <Card className={`shadow border-0`} style={{marginTop: 25}}>
                                <CardHeader
                                    className="bg-primary text-white">{editContainerFunctionType.name}</CardHeader>
                                <CardBody>
                                    <form className="row" noValidate autoComplete="off">
                                        <div className="col-lg-3 col-md-3 col-12">
                                            <TextField
                                                id="username"
                                                label="نام کاربری (موبایل)"
                                                value={username}
                                                onChange={this.handleChange('username')}
                                                margin="normal"
                                                fullWidth
                                                disabled={editContainerFunctionType == formFunctionTypes.Edit}
                                            />
                                            {this.validator.message('نام کاربری', username, 'required|mobile')}
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-12">
                                            <div className='row'>
                                                <TextField
                                                    id="password"
                                                    label="کلمه عبور"
                                                    value={password}
                                                    onChange={this.handleChange('password')}
                                                    margin="normal"
                                                    disabled={!changePassword && editContainerFunctionType == formFunctionTypes.Edit}
                                                    type='password'
                                                    fullWidth
                                                />
                                                {this.validator.message('کلمه عبور', password, 'required|min:8')}
                                                <div>
                                                    {editContainerFunctionType == formFunctionTypes.Edit &&
                                                    <FormControlLabel
                                                        control={
                                                            <Checkbox
                                                                checked={changePassword}
                                                                onChange={this.handleSwitchChange('changePassword')}
                                                                value="changePassword"
                                                            />
                                                        }
                                                        label="تغییر اجباری کلمه عبور"
                                                    />
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-12">
                                            <TextField
                                                id="nickName"
                                                label="نام مستعار"
                                                value={nickName}
                                                onChange={this.handleChange('nickName')}
                                                margin="normal"
                                                fullWidth
                                            />
                                            {this.validator.message('نام مستعار', nickName, 'required')}
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-12">
                                            <div>
                                                <Switch
                                                    classes={{
                                                        checked: 'text-primary',
                                                        bar: 'bg-primary',
                                                    }}
                                                    checked={isActive}
                                                    onChange={this.handleSwitchChange('isActive')}
                                                    aria-label="isActive"
                                                />
                                                <span>کاربر فعال می باشد؟</span>
                                            </div>
                                            <div>
                                                <Switch
                                                    classes={{
                                                        checked: 'text-secondary',
                                                        bar: 'bg-secondary',
                                                    }}
                                                    checked={enableNotification}
                                                    onChange={this.handleSwitchChange('enableNotification')}
                                                    aria-label="enableNotification"
                                                />
                                                <span>اطلاع رسانی فعال می باشد؟</span>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-12">
                                            <TextField
                                                id="firstName"
                                                label="نام"
                                                value={firstName}
                                                onChange={this.handleChange('firstName')}
                                                margin="normal"
                                                fullWidth
                                            />
                                            {this.validator.message('نام', firstName, 'required')}
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-12">
                                            <TextField
                                                id="lastName"
                                                label="نام خانوادگی"
                                                value={lastName}
                                                onChange={this.handleChange('lastName')}
                                                margin="normal"
                                                fullWidth
                                            />
                                            {this.validator.message('نام خانوادگی', lastName, 'required')}
                                        </div>
                                        <div className="col-lg-6 col-md-6 col-12">
                                            <TextField
                                                id="bio"
                                                label="بیوگرافی"
                                                value={bio}
                                                onChange={this.handleChange('bio')}
                                                margin="normal"
                                                fullWidth
                                            />
                                        </div>
                                        <div className="col-lg-8 col-md-8 col-12">
                                            <div className='row mt-3'>
                                                <div className='col-lg-12'>
                                                    <div className='row'>
                                                        <div className='col-lg-12'>
                                                            <h3>نقش های کاربر</h3>
                                                            <div style={{
                                                                flexGrow: 1,
                                                                minHeight: 70,
                                                                justifyItems: 'center',
                                                            }}>
                                                                <Input
                                                                    fullWidth
                                                                    inputComponent={SelectWrapped}
                                                                    inputProps={{
                                                                        classes,
                                                                        value: userRoles,
                                                                        multi: true,
                                                                        onChange: this.handleChangeMulti,
                                                                        placeholder: 'کاربر فاقد نقش، نقش ها را انتخاب کنید...',
                                                                        instanceId: 'react-select-chip',
                                                                        id: 'react-select-chip',
                                                                        name: 'react-select-chip',
                                                                        simpleValue: true,
                                                                        options: userRolesData,
                                                                    }}
                                                                />
                                                            </div>
                                                            {this.validator.message('نقش های کاربر', userRoles, 'required')}
                                                        </div>
                                                    </div>
                                                    {isProducer &&
                                                    <div className='row mt-4'>
                                                        <div className='col-12'>
                                                            <h3>اطلاعات فروشندگی</h3>
                                                        </div>
                                                        <div className="col-lg-8 col-md-8 col-12">
                                                            <TextField
                                                                id="producerName"
                                                                label="عنوان فروشگاه"
                                                                value={producerName}
                                                                onChange={this.handleChange('producerName')}
                                                                margin="normal"
                                                                fullWidth
                                                            />
                                                            {this.validator.message('عنوان فروشگاه', producerName, 'required')}
                                                        </div>
                                                        <div className="col-lg-4 col-md-4 col-12">
                                                            <TextField
                                                                id="partnerPercent"
                                                                label="درصد شراکت تولیتون"
                                                                value={partnerPercent}
                                                                onChange={this.handleChange('partnerPercent')}
                                                                margin="normal"
                                                                fullWidth
                                                            />
                                                            {this.validator.message('درصد شراکت', partnerPercent, 'required')}
                                                        </div>
                                                    </div>
                                                    }
                                                </div>
                                                <div className='row mt-4'>
                                                    <div className="col-lg-6 col-md-6 col-12">
                                                        <TextField
                                                            id="createDate"
                                                            label="تاریخ ایجاد"
                                                            value={createDate}
                                                            margin="normal"
                                                            disabled={true}
                                                            fullWidth
                                                        />
                                                    </div>
                                                    <div className="col-lg-6 col-md-6 col-12">
                                                        <TextField
                                                            id="lastModified"
                                                            label="آخرین ویرایش"
                                                            value={lastModified}
                                                            margin="normal"
                                                            disabled={true}
                                                            fullWidth
                                                        />
                                                    </div>
                                                    <div className="col-lg-6 col-md-6 col-12">
                                                        <TextField
                                                            id="lastLoginDate"
                                                            label="تاریخ آخرین ورود"
                                                            value={lastLoginDate}
                                                            margin="normal"
                                                            disabled={true}
                                                            fullWidth
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-4 col-md-4 col-12">
                                            <Card className={'shadow border-0 bg-secondary'}>
                                                <CardBody className="text-center">
                                                    <h3 className="card-title">تصویر کاربری</h3>
                                                    <ImageThumbs props={this}/>
                                                    <Dropzone props={this}/>
                                                </CardBody>
                                            </Card>
                                        </div>
                                        <div className="col-6">
                                        </div>
                                    </form>
                                </CardBody>
                                <CardFooter>
                                    <div style={{textAlign: 'left'}}>
                                        <Button variant="raised" className="jr-btn bg-success jr-btn-sm text-white"
                                                style={{marginLeft: 10}} onClick={this.submitBtn.bind(this)}>
                                            <i className="zmdi zmdi-check zmdi-hc-fw"/>
                                            <span>ثبت</span>
                                        </Button>
                                        <Button variant="raised" className="jr-btn bg-red jr-btn-sm text-white"
                                                style={{marginLeft: 10}} onClick={this.closeEditContainer.bind(this)}>
                                            <i className="zmdi zmdi-close zmdi-hc-fw"/>
                                            <span>انصراف</span>
                                        </Button>
                                    </div>
                                </CardFooter>
                            </Card>
                        </section>
                    )}
                </div>
            </div>
        );
    }
}

Users.propTypes = {
    classes: PropTypes.object.isRequired,
};


export default withStyles(styles)(Users);



// WEBPACK FOOTER //
// ./app/routes/toliton/users/users.js